import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';
import { onResultWithDataStatus } from 'Shared/HttpServices/Utils/utils';

import IGetCodeShenasehPardakhtShakhsSalesCommand from '../SakhsSalesBimehNameh/Commands/Soddor/IGetCodeShenasehPardakhtShakhsSalesCommand';
import { KhodroHttpPostService } from '../Services/KhodroHttpService';

export const getCodeShenasehPardakhtShakhsSalesWithoutPelak = createAsyncThunk(
  'getCodeShenasehPardakhtShakhsSalesWithoutPelak',
  async (command: IGetCodeShenasehPardakhtShakhsSalesCommand) => {
    return await KhodroHttpPostService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.CreateShenasehPardakhtWithoutPelak}`,
      body: command,

      onResult: onResultWithDataStatus,
    });
  }
);
